<div
  style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; place-content: stretch center; align-items: stretch; height:100%">
  <div
    style="flex-direction: column; box-sizing: border-box; display: flex; place-content: stretch flex-start; align-items: stretch; flex: 1 1 100%; max-width: 50%;">
    <div style="flex: 1 1 100%; box-sizing: border-box; max-height: 8%">
    </div>
    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
      <div style="flex: 1 1 0%; box-sizing: border-box;">
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
          <mat-toolbar color="primary"
            style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;"
            class="toolbar-over-card">
            Download by Verified Email
          </mat-toolbar>
          <div *ngIf="isLoading && isValidLink" style="overflow-y: auto; flex: 1 1 0%; box-sizing: border-box;">
            <mat-card appearance="outlined">
              <mat-card-content class="content">
                <div class="title">Loading...</div>
              </mat-card-content>
            </mat-card>
          </div>
          <div *ngIf="!isLoading && isValidLink" style="overflow-y: auto; flex: 1 1 0%; box-sizing: border-box;">
            <mat-card appearance="outlined" style="padding-top: 5px;">
              <mat-card-content class="content">
                <div *ngIf="!codeRequested && !userConfirmed" style="display: flex;
                flex-direction: column;
                gap: 12px;
                padding: 24px 2px;">
                  <b>Submit email address to be verified.</b>
                  <mat-error *ngIf="requestErrorFeedback">{{requestErrorFeedback}}</mat-error>
                  <form [formGroup]="emailForm">
                    <mat-form-field>
                      <input matInput placeholder="Email" formControlName="email" required>
                      <mat-error *ngIf="emailForm.controls['email'].invalid">
                        <p *ngIf="emailForm.controls['email'].errors.required">Email address is
                          <strong>required</strong>
                        </p>
                        <p *ngIf="emailForm.controls['email'].errors.email"> Please enter a valid email address.
                        </p>
                      </mat-error>
                    </mat-form-field>
                  </form>
                </div>
                <div *ngIf="codeRequested && !userConfirmed" style="display: flex;
                flex-direction: column;
                gap: 12px;
                padding: 24px 2px;">
                  <b>Submit your code for verification.</b>
                  <div *ngIf="feedback">{{feedback}}</div>
                  <mat-error *ngIf="errorFeedback">{{errorFeedback}}</mat-error>
                  <form [formGroup]="codeVerificationForm">
                    <mat-form-field>
                      <input matInput placeholder="Code" formControlName="codeVerification" required>
                      <mat-error *ngIf="codeVerificationForm.controls['codeVerification'].invalid">
                        <p *ngIf="codeVerificationForm.controls['codeVerification'].errors.required">Verification code is required.
                        </p>
                        <p *ngIf="codeVerificationForm.controls['codeVerification'].errors.pattern">The code must be exactly 6 digits.
                        </p>
                      </mat-error>
                    </mat-form-field>
                  </form>
                  <div>
                    <span>Having trouble? </span><span (click)="codeRequested=false" style="cursor: pointer;" [ngClass]="{'gold':isDarkMode(), 'blue': !isDarkMode()}"> Click here to resubmit your email...</span>
                  </div>
                </div>
                <div *ngIf="userConfirmed">
                  <div *ngIf="parts?.length">
                    <div style="margin: 25px 0;">
                      <span style="font-weight:600">{{productionJob.title}}</span> is now ready for
                      download!
                    </div>
                  </div>
                  <div style="min-width: 375px; padding-right: 24px; margin-bottom: 25px;">
                    <div *ngIf="parts?.length > 1">
                      <div *ngFor="let url of parts; index as i"  class="download-row-link">
                        <div class="download-row" (click)="downloadPart(url,i)">
                          <div class="fa-duotone fa-download" style="padding: 0 14px;"></div>
                          <div>Download part {{i + 1}} <span *ngIf="downloadingStatus[i]">has started in another window. If there is no progress in the browser's Downloads section after 5 minutes, please try again.</span> </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="parts?.length === 1">
                      <div class="download-row-link">
                        <div class="download-row" (click)="downloadPart(parts[0],0)">
                          <div class="fa-duotone fa-download" style="padding: 0 14px;"></div>
                          <div>Download production now <span *ngIf="downloadingStatus[0]">has started in another window. If there is no progress in the browser's Downloads section after 5 minutes, please try again.</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="parts !== null && parts.length < 1 && hasProductionFinishedRunning">
                    <div style="margin-top: 25px;">
                      <span style="font-weight:600">{{productionJob.title}}</span> is being prepared
                      and will be available for
                      download shortly. This could take several minutes depending on the size of the
                      production.
                    </div>
                    <div style="display: flex; justify-content: center">
                      <mat-spinner [diameter]="35" color="primary" style="margin: 25px;"></mat-spinner>
                    </div>
                  </div>
                  <div *ngIf="parts !== null && parts.length < 1 && !hasProductionFinishedRunning">
                    <div style="margin-top: 25px;">
                      <span style="font-weight:600">{{productionJob.title}}</span> is being processed
                      and may take a while before it is available for download. Please check back soon!
                    </div>
                  </div>
                  <mat-error *ngIf="linkErrorFeedback">{{linkErrorFeedback}}</mat-error>
                  <form *ngIf="productionJob?.hasPassword && parts === null" [formGroup]="downloadForm">
                    <mat-form-field>
                      <input matInput placeholder="Enter download password" [type]="hidePassword ? 'password' : 'text'"
                        formControlName="password" required>
                      <mat-icon matSuffix
                        (click)="hidePassword = !hidePassword">{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                      <mat-error *ngIf="downloadForm.controls['password'].invalid">
                        <p *ngIf="downloadForm.controls['password'].errors.required">Password is
                          <strong>required</strong>
                        </p>
                      </mat-error>
                    </mat-form-field>
                  </form>
                </div>
              </mat-card-content>
              <mat-card-actions style="display: flex; justify-content: space-between;">
                <div>
                  <img *ngIf="!isDarkMode()" id="maincontent_imgLexbeLogo" style="height:30px"
                    src="/assets/images/lexbe-logo.svg">
                  <img *ngIf="isDarkMode()" id="maincontent_imgLexbeLogo" style="height:30px"
                    src="/assets/images/lexbe-logo-dark-theme-3.svg">
                </div>
                <div style="padding-bottom: 10px;">
                  <button *ngIf="!codeRequested && !userConfirmed" mat-raised-button color="primary" (click)="requestCode()"
                    [disabled]="isLoading || emailForm.invalid" (keydown.enter)="requestCode()">
                    Request Code
                  </button>
                  <button *ngIf="codeRequested && !userConfirmed" mat-raised-button color="primary" (click)="verifyCode()" 
                  [disabled]="isLoading || codeVerificationForm.invalid" (keydown.enter)="verifyCode()">
                    Submit Code
                  </button>
                  <button *ngIf="userConfirmed && productionJob?.hasPassword && parts === null" mat-raised-button color="primary"
                    [disabled]="(productionJob?.hasPassword && downloadForm.invalid) || requestLinks" (click)="getDownloadParts()" (keydown.enter)="getDownloadParts()">
                    CONTINUE
                  </button>
                </div>
              </mat-card-actions>
            </mat-card>
          </div>
          <div style="overflow-y: auto; flex: 1 1 0%; box-sizing: border-box;" *ngIf="!isValidLink">
            <mat-card appearance="outlined">
              <mat-card-content class="content">
                <div class="title">This download production link is invalid or has expired.</div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
    <div style="flex: 1 1 100%; box-sizing: border-box; max-height: 8%">
    </div>
  </div>
</div>